import { v4 as uuidv4 } from "uuid";
const constants = {
  ACTIVE_OFFICES_PAGE_SIZE: 400,
  OFFICE_PAGE_SIZE_100: 100,
  subscriptionTerminated: "subscriptionTerminated",
  MAX_FILE_SIZE_5_MB: 5 * 1024 * 1024,
  MAX_FILE_SIZE_512_MB: 512 * 1024 * 1024,
  ALLOWED_TYPESALLOWED_TYPES: [".pdf", ".docx", ".txt"],
  ALLOWED_MIME_TYPES: [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
    "text/plain",
  ],
  sizeUnits: ["Bytes", "KB", "MB", "GB"],
  staffActionEvents: {
    activation: 0,
    deactivation: 1,
    removal: 2,
    removalAsAdmin: 3,
    cancelInvitation: 4,
    multipleActivationConfirm: 5,
    multipleActivationOffice: 6,
    multipleDeactivationConfirm: 7,
    multipleRemoveConfirm: 8,
    multipleCancelConfirm: 9,
  },
  cache: {
    ownerKey: "commonSelectedOwner",
  },
  packageTypes: {
    trial: "trial",
    free: "free",
  },
  selectedOwnerId: "globalSelectedId",
  routes: {
    home: "/",
    globalStaffList: "/global-staff-lists",
    globalStaffAdd: "/global-staff-add",
    callViewNew: "/call-view-new",
    paymentfailed: "/paymentfailed",
    findDoctors: "/find-doctors",
    officeStaffs: "/offices-Staff",
    appVersionList: "/app-version",
    appVersionForm: "/app-version/form",
    specialtyList: "/specialty",
    specialtyForm: "/specialty/form",
    account: "/account",
    addSubscription: "/add-subscription",
    paymentDetailsNew: "/payment-details-new",
    setupCard: "/setup-card",
    doctors: "/doctors",
    searchDoctorBySpecialty: "/doctor-by-specialty",
    doctor: "/doctor",
    watingListRequest: "/doctor/waiting-list-form",
    setLocation: "/set-location",
    doctorOffices: "/doctor/:doctorId/offices",
    editProfile: "/edit-profile",
    changePassword: "/change-password",
    termsAndConditions: "/terms-conditions",
    privacyPolicy: "/privacy-policy",
    aboutMiraxis: "/about-us",
    termsAndConditionsPatient: "/terms-conditions-for-patient",
    termsAndConditionsVendor: "/terms-conditions-for-vendor",
    privacyPolicyPatient: "/privacy-policy-for-patient",
    privacyPolicyVendor: "/privacy-policy-for-vendor",
    viewProfile: "/profile",
    doctorReviews: "/doctor/reviews",
    requestAnAppointment: "/doctor/request-appointment",
    downloadIcs: "/download-ics",
    chatModule: "/team-conversation",
    patientChatModule: "/patient-conversation",
    conversationRedirection: "/conversation-redirection",
    patientWithOwnerOrDoctorChatModule: "/doctors-conversation",
    patientListOfAppointment: "/patient-list-appointment",
    notes: "/notes",
    noteDetails: "/my-note-details/:noteId",
    transferredNoteDetails: "/transferred-details/:noteId",
    addNote: "/addNote",
    questionnaireForm: "/questionnaire-form",
    getStarted: "/getstarted",
    waitingList: "/waiting-list/:officeId",
    waitingAppoimentDetail: "/waiting-appointment-detail/:officeId/:requestId",
    familyMembers: "/family-members",
    addNewMember: "/add-new-member",
    editMember: "/edit-member/:memberId",
    viewMember: "/view-member/:memberId",
    demoRequestPage: "/demo-request-page",
    demoRequestThank: "/demo-request-thank-page",
    pmsMembers: "/pms-members/:officeId",
    accountPreferences: "/account-preferences",
    appointementConfirmationForNonMiraxis:
      "/confirm-appointment/:appointmntId/:officeId",

    taskManagements: {
      taskManagement: "/task-management",
      taskManagementAddNote: "/task-management-add-note",
      taskManagementEditNote: "/task-management-edti-note/:taskId",
      taskDetails: "/staff-task-details/:taskId",
      ownerTaskDetails: "/owner-task-details/:taskId",
      patientDetails: "/patient-details",
      taskPerformance: "/task-performance",
      performanceDetail: "/performance-detail/:userId/:officeId",
    },
    officePolicyManagements: {
      officePolicyManagement: "/office-policy-management",
      officePolicyManagementLatestPolicy:
        "/office-policy-management/:policyFolderId/policies",
      policyLogsListing: "/office-policy-management-logs-listing",
      policyDetailsHistoryLogs:
        "/office-policy-management-details-history-logs/:policyId",
      policyDocumentListing:
        "/office-policy-management/:officePolicyFolderId/policy-document-listing",
      officePolicyManagementAddPolicyFolder:
        "/office-policy-management-add-policy-folder",
      officePolicyManagementEditPolicyFolder:
        "/office-policy-management-edit-policy-folder/:officePolicyId",
      officePolicyManagementAddPolicy:
        "/office-policy-management/:officePolicyFolderId/office-policy-management-add",
      officePolicyManagementEditPolicy:
        "/office-policy-management/:officePolicyFolderId/office-policy-management-edit/:policyId",
      officePolicyManagementOwnerDetailView:
        "/office-policy-management/:officePolicyFolderId/owner-office-policy-management-view",
      officePolicyManagementDetails:
        "/office-policy-management-details/:officePolicyId",
      ownerOfficePolicyManagementDetails:
        "/owner-office-policy-management-details/:officePolicyId",
      renewAcknowledgement:
        "/office-policy-management-details/renew-acknowledgement",
      officePolicyManagementPerformance:
        "/office-policy-management-performance",
      officePolicyManagementPerformanceDetail:
        "/office-policy-management-performance-detail/:userId/:officeId",
    },
    credentialsAndLicensing: {
      credentialsAndLicensing: "/credentials-licensing",
      credentialsAndLicensingGlobal: "/credentials-licensing-global",
      credentialsAndLicensingGlobalDetail: "/credentials-licensing-global/:id",
    },
    staffAttendance: {
      staffAttendance: "/staff-attendance",
    },
    blogs: {
      blog1: "/blogs/9-reasons-why-dentists-are-automating-their-practice",
      blog2: "/blogs/top-9-ways-for-you-and-your-staff-to-avoid-burnout",
      blog3:
        "/blogs/top-9-benefits-of-streamlining-and-automating-workflows-in-your-dental-practice",
      blog4:
        "/blogs/communication-with-your-team-how-to-be-hands-offand-still-be-hands-on",
      blog5:
        "/blogs/3-effective-ways-technology-can-help-you-efficiently-manage-staff-in-your-practice",
      blog6:
        "/blogs/8-ways-leading-dental-practices-enhance-their-staff-experience",
      blog7: "/blogs/6-ways-to-recruit-and-retain-practice-employees",
    },
    landingPages: {
      guideDownloadPage: "/landing-pages/guide-download-page",
      guideThankPage: "/landing-pages/guide-thank-page",
      ebookDownloadPage: "/landing-pages/ebook-download-page",
      ebookThankPage: "/landing-pages/ebook-thank-page",
      guideDownloadPageFb: "/landing-pages/guide-download-page-fb",
      guideDownloadPageGgl: "/landing-pages/guide-download-page-ggl",
      guideDownloadPageSm: "/landing-pages/guide-download-page-sm",
      ebookDownloadPageFb: "/landing-pages/ebook-download-page-fb",
      ebookDownloadPageGgl: "/landing-pages/ebook-download-page-ggl",
      ebookDownloadPageSm: "/landing-pages/ebook-download-page-sm",
    },
    vendor: {
      dashboard: "/vendor-dashboard",
      manageOrders: "/manage-orders",
      manageCatalogue: "/manage-catalogue",
      manageCustomers: "/manage-customers",
      promotion: "/promotion",
      promoCodes: "/promocodes",
      topup: "/topup",
      supportHelpdesk: "/support-helpdesk",
      manageSalesRep: "/manage-sales-rep",
      manageInvoices: "/manage-invoices",
      addNewItem: "/add-new-item",
      catalogueDetail: "/catalogue-detail",
      addNewTicket: "/add-new-ticket",
      ticketDetail: "/vendor-ticket-detail/:id",
      customerDetail: "/customer-detail/:id",
      inviteCustomers: "/invite-customers",
      vendorProfile: "/vendor-profile",
      orderDetail: "/order-detail/:orderId",
      addPromoCode: "/add-new-promocode",
      addPromotion: "/add-new-promotion",
      promotionDetail: "/promotion-detail/:promotionId",
      inviteSalesRep: "/invite-sales-rep",
      editSalesRep: "/edit-sales-rep",
      salesRepDetail: "/sales-rep-detail",
      accountSetup: "/vendor-account-setup",
      editProfile: "/vendor-edit-profile",
      cardSetup: "/vendor-card-setup",
      bankSetup: "/vendor-bank-setup",
      paymentSuccess: "/vendor-payment-success",
      manageSubscription: "/manage-subscription",
      manageVendorCards: "/manage-vendor-cards",
      editVendorCards: "/edit-vendor-cards",
      changeSubscription: "/change-subscription",
      vendorPurchaseSubscription: "/vendor-purchase-subscription",
    },
    accountOwner: {
      offices: "/offices",
      addOffice: "/AddOffice",
      editOffice: "/editOffice",
      officeOptions: "/office/:officeId",
      staffGrid: "/staff/:officeId",
      officeStaffInformation: "/office-staff-info/:officeId",
      globalOfficeStaffInformation: "/global-office-staff-info",
      addStaff: "/AddStaff/:id",
      editStaff: "/editStaff/:id",
      updateMultipleStaffForSingleOffice: "/bulk-update-multistaff-office",
      updateStaffForMultipleOffices: "/update-staff-across-offices",
      updateMultipleStaffForMultipleOffices:
        "/bulk-update-multistaff-multioffices",
      staffDetail: "/staff-detail",
      preferences: "/office/:officeId/preferences",
      submissionPreferences: "/office/:officeId/submission-preferences",
      fiscalYear: "/fiscal-year/:officeId",
      timelinePreferences: "/timeline-preferences/:officeId",
      discussionNotes: "/discussion-notes/:officeId",
      discussionNotesDetail: "/discussion-notes-detail/:staffId",
      geoFence: "/office/:officeId/geo-fence",
      managePlan: "/manage-plan",
      manageHolidays: "/manage-holidays",
      staffRoles: "/staff-roles",
      viewFeatures: "/view-plan",
      manageCards: "/manage-cards",
      changePlan: "/change-plan",
      addSubscription: "/add-subscription",
      selectOffice: "/Select-Office",
      profile: "/profile",
      contracts: "/contracts/:officeId",
      forms: "/forms/:officeId",
      myForms: "/my-forms/:officeId",
      employementProof: "/employement-proof/:officeId",
      myEmployementProof: "/my-employment-proof/:officeId",
      employmentProofForm: "/employment-proof-form/:officeId",
      employmentProofFormReview: "/employment-proof-form-review",
      performanceReview: "/performance-review/:officeId",
      myPerformanceReview: "/my-performance-review/:officeId",
      addNewPerformanceReview: "/add-performance-review/:officeId",
      staffContracts: "/staff-contracts/:officeId/:staffId",
      newContract: "/new-contract/:officeId/:staffId",
      editContract: "/edit-contract/:officeId/:staffId/:contractId",
      viewContract: "/view-contract/:officeId/:contractId",
      timesheet: "/timesheet/:officeId",
      leaves: "/leaves/:officeId",
      officesList: "/offices-list",
      performanceReviewForm: "/performance-review-form/:officeId",
      previewReviewForm: "/preview-performance-review-form",
      notices: "/notices/:officeId",
      myNotices: "/my-notices/:officeId",
      addNotice: "/add-notice/:officeId",
      noticeDetails: "/notice-details/:noticeId",
      myNoticeDetails: "/my-notice-details/:noticeId",
      updateTimesheetForStaff: "/timesheet/:officeId/:staffId",
      editTimesheetForStaff: "/edittimesheet/:officeId/:staffId",
      timesheetReport: "/timeheet/:officeId/timesheet-report",
    },
    staff: {
      offices: "/staff-offices",
      adminStaffListing: "/Staff/:id",
      staffDetail: "/staff-detail",
      globaleStaffDetail: "/global-staff-detail",
      hourlyRate: "/hourly-rate-history",
      officeOptions: "/staff-office/:officeId",
      officeAdmin: "/staff-admin/:officeId",
      officeContracts: "/office-contracts/:officeId",
      viewContract: "/view-staff-contract/:officeId/:contractId",
      timesheet: "/staff-office/:officeId/timesheet",
      timesheetSummary: "/timesheet-summary",
      timesheetViewDetail: "/timesheet-view-detail",
      staffListingTimesheet: "/timesheet/:officeId",
      timesheetDetail: "/timeheet/:officeId/timesheet-detail/:userId",
      timesheetDateDetail: "/timesheet-date-detail",
      leaves: "/leaves/:officeId",
      applyLeaves: "/apply-leaves/:officeId",
      editLeaves: "/edit-leaves/:officeId",
      leavesHistoryLogs: "/leaves-history-logs/:leaveId",
    },

    superAdmin: {
      patientList: "/manage-patients",
      reviews: "/reviews",
      patientReviews: "/reviews/patient/:patientId",
      doctorReviews: "/reviews/doctor/:doctorId",
      broadCastMessages: "/broadcast-messages",
      createBroadCastMessage: "/create-broadcast-message",
      appointmentRequestList: "/appointment-request-list",
      vendorSubscriptionPlans: "/vendor-subscription-plans",
      appointmentRequestDetail: "/appointment-request-detail/:requestId",
      feedback: "/feedbackandsuggestions",
      feedbackView: "/feedbackview/:feedbackId",
      SupportAndHelp: "/support",
      supportTicketDetail: "/ticket-detail/:ticketId",
      editSubscription: "/edit-subscription/:subscriptionId",
      categories: "/categories",
      tax: "/tax",
      sales: "/sales",
      trialSubscription: "/trial-subscription",
      basicSubscription: "/basic-subscription",
      vendorSubscriptionView: "/view-subscription/:subscriptionType",

      enterpriseSubscription: "/enterprise-subscription",
      manageVendors: "/manage-vendors",
      VendorDetails: "/vendor-details/:vendorId",
      VendorProfile: "/admin-vendor-profile",
      TopUpPromotions: "/top-up-promotions",
      helpDesk: "/help-desk",
      ticketDetails: "/helpdesk-ticket-details",
      manageCommissions: "/manage-commissions",
      manageSalesRepAdmin: "/manage-sale-representatives",
      accountBasicSubscription: "/subscription-details/:subscriptionType",
      editAccountBasicSubscription: "/update-subscription/:subscriptionType",
      manageFeatures: "/manage-features",
      editBasicSubscription: "/edit-subscription",

      editVendorSubscription: "/edit-vendor-subscription/:subscriptionType",
      addNewPlan: "/add-vendor-enterprise-plan",
      editEnterPricePlan: "/edit-vendor-enterprise-plan",
      enterpriseSubscriptionDetails: "/enterprise-subscription-details",
      addNewVendor: "/add-new-vendor",
      editAssignedVendor: "/edit-assigned-vendor",
      vendorSubscriptionDetails: "/vendor-subscription-details",
      editSubscriptionForVendors: "/edit-vendor-subscription-price",
      vendorTransactionHistory: "/vendor-transaction-history",

      appointmentDashboard: "/appointment-dashboard/:officeId",
    },

    appointment: {
      appointmentScreen: "/appointments",
      patients: "/patients/:officeId",
      patientDetail: "/patient-detail/:officeId/:patientId",
      patientNotes: "/patient-notes/:officeId/:patientId",
      addPatientNotes: "/add-patient-notes/:officeId/:patientId",
      patientMessageCenter:
        "/patient-message-center/:officeId/:patientId?/:appointmentId?",
      patientNewMessage:
        "/patient-new-message/:officeId/:patientId?/:appointmentId?",
      createMessageHistoryTemplates:
        "/create-message-history-template/:officeId/:patientId?",
      patientViewTemplate: "/patient-view-template",
      patientStatus: "/patient-status/:officeId/:patientId",
      patientNoteDetail:
        "/patient-note-detail/:officeId/:patientId/:patientNoteId",
      manageSchedule: "/manage-schedule",
      urbanDental: "/urban-dental",
      officeSelection: "/office-manage-schedule/:officeId",
      doctorSelection: "/doctor-selection/:officeId/:patientId?",
      createAppointment: "/create-appointment/:officeId/:requestId",
      appointmentType: "/appointment-type/:officeId/:requestId",
      appointmentReminder: "/appointment-reminder/:officeId/:requestId",
      createMessageTemplates: "/create-message-template/:officeId/:requestId",
      trackSchedule: "/track-schedule-change/:officeId?",
      recallAppointment: "/create-recall-appointment",
      selectNextRecall: "/select-next-recall",
      selectDateTime: "/select-date-time",
      addNewAppointment: "/add-new-appointment/:appointmentId",
      submittedQuestionnaire: "/submitted-questionnaire/:appointmentId",
      covingQuestionnaire: "/covid-questionnaire/:appointmentId",
      patientAppointmentDetails: "/patient-appointment-details/:appointmentId",
      acceptPatientAppointment: "/accept-patient-appointment/:appointmentId",
      patientAppointmentType: "/patient-appointment-type/:appointmentId",
      patientReminderPlan: "/patient-reminder-plan",
      feedbackConfirmation: "/feedback-confirmation/:officeId/:appointmentId",
      editRecall: "/edit-recall",
      reassignAppointment: "/reassign-appointment/:appointmentId/:officeId",
      rescheduleAppointment: "/reschedule-appointment/:appointmentId/:officeId",
      reassignDateTime: "/reassign-date-time",
      addAppointmentReminderPlan: "/add-reminder-plan/:officeId/:requestId",
      seeTodaySchedule: "/see-today-schedule",
      selectAppointmentType: "/select-appointment-type",
      selectReminderPlan: "/select-reminder-plan",
      patientNewAppointment:
        "/patient-new-appointment/:officeId?/:doctorId?/:patientId?",
      selectPatientAppointmentType: "/select-patient-appointment-type",
      selectPatientAppointmentReminderPlan:
        "/select-patient-appointment-reminder-plan",
      linkToNextRecall: "/link-to-next-recall/:appointmentId",
      recall: "/recall/:appointmentId",
      reminder: "/reminder/:appointmentId/:officeId",
      recallPatientAppointmentType: "/recall-patient-appointment-type",
      recallPatientReminderPlan: "/recall-patient-reminder-plan",
      pastPatientReminderPlan: "/past-patient-reminder-plan",
      createRecallPatientAppointment:
        "/create-recall-patient-appointment/:appointmentId",
      recallReminderEdit: "/recall-reminder-edit/:appointmentId/:officeId",
      nextEditRecall: "/next-edit-recall/:appointmentId/:officeId",
      globalReminder: "/global-reminder/:officeId/:patientId",
      patientAppointmentReminder:
        "/patient-appointment-reminder/:officeId?/:patientId?",
      patientAddAppointmentReminderPlan:
        "/patient-add-reminder-plan/:officeId?/:patientId?",
      AccountGlobalReminder: "/global-reminder",
      AccountGlobalOfficeReminder: "/global-office-reminder/:officeId",
    },

    scheduler: {
      calendar: "/scheduler",
      addEvent: "/add-event",
      editEvent: "/edit-event/:eventId",
      duplicateEvent: "/duplicate-event/:eventId",
      deleteEvent: "/delete-event/:eventId",
      deleteBusySlot: "/delete-busySlot/:busySlotId",
      eventDetails: "/event-details/:eventId",
      eventRequestDetails: "/event-request-details/:eventId",
      EventWorkingDetails: "/event-working-details/:eventId",
      addBusySlot: "/add-busy-slots",
      editBusySlot: "/edit-busy-slots/:busySlotId",
      duplicateBusySlot: "/duplicate-busy-slots/:busySlotId",
      busySlotDetail: "/busy-slot-detail/:busySlotId",
      eventDetailsOnly: "/event-details-only/:eventId",
      eventHistoryLogs: "/event-history-logs/:eventId",
      busySlotHistoryLogs: "/busySlot-history-logs/:busySlotId",
    },
    dashboard: {
      managerDashboard: "/manager-dashboard",
    },

    notification: {
      notificationDetail: "/notification",
    },

    accountPreference: {
      messageTemplates: "/message-templates",
      addMessageTemplates: "/add-message-templates",
      editMessageTemplates: "/edit-message-templates/:templateId",
      viewMessageTemplates: "/view-message-template/:templateId",
      companyBranding: "/company-branding",
      policyAcknowledgementTemplate: "/policy-acknowledgement-template",
    },

    aiAssistant: {
      aiSetting: "/ai-settings",
      manageSystemInstruction: "/manage-system-instruction",
      manageDocuments: "/manage-documents",
      managePrompts: "/manage-prompts",
      addPrompt: "/add-prompt",
      editPrompt: "/edit-prompt/:promptId",
      viewPrompt: "/view-prompt/:promptId",
      ratingResponses: "/ratings-reviews",
      ratingResponseView: "/ratings-response-view",
      chatHistory: "/chat-history",
      chatHistoryView: "/chat-history-view",
      reportedResponse: "/reported-response",
      reportedResponseView: "/reported-response-view",
      manageAiDocuments: "/manage-ai-documents",
      viewManageAiDocuments: "/view-manage-ai-documents",
    },

    help: "/help",
    faq: "/faq",
    onlineHelp: "/onlineHelp",
    feedback: "/feedback",
    contact: "/contact",
  },
  staffType: {
    activated: 1,
    deactivated: 2,
    invitationPending: 3,
    invitationDeclined: 4,
    removed: 5,
  },
  systemRoles: {
    superAdmin: 1,
    accountOwner: 2,
    staff: 3,
    patient: 4,
    vendor: 5,
  },

  localStorageKeys: {
    agenda: {
      staffFilter: "agenda-staff-filter",
      officeFilter: "agenda-office-filter",
      eventFilter: "agenda-event-filter",
      eventWorkspaceEventFilter: "event-workspace-event-filter",
      enterprise: "agenda-event-enterprise",
      staffSchedulerEnterprise: "staff-schedule-event-enterprise",
      eventWorkspaceEnterprise: "event-workspace-enterprise",
      eventShift: "event-shift",
      draftPublish: "draft-publish",
      invitationRequestEnterprise: "invitation-request-enterprise",
      otherOfficesEnterprise: "other-offices-enterprise",
      weeklySettingFilter: "view-setting-filter-weekly",
      monthlySettingFilter: "view-setting-filter-monthly",
      mySettingFilter: "my-view-setting-filter",
      eventEmployeeFilter: "event-employee-filter",
    },
    waitingListFormData: "request-waiting-list-form-data",
    requestAppointmentData: "request-appointment-form-data",
    staffAvailablilityFilter: "staff-availability-filter",
    doctorListLocation: "saved-geolocation",
    selectedChatAccountOwner: "selected-chat-account-owner",
    selectedChatAccountOwnerForPatient: "selected-chat-account-owner-patient",
    questionnaireResponse: "questionnaire-response",
    filledQuestionnaireData: "filled-questionnaire-data",
    selectedAppointmentDate: "selected-appointment-date",
    activeChatTab: "active-chat-tab",
    paymentMethod: "paymentMethod",
    persistOfficeFilter: "Selected_Offices",
    persistRoleFilter: "Selected_Team_Chat_Roles",
    complianceAnalytics: {
      appliedFilters: "compliance-analytics-applied-filters",
      filterState: "compliance-analytics-filter-state",
    },
  },

  /** Session keys (not persisted in localStorage). */
  sessionStorageKeys: {
    /**
     * Set while logging out so App shows the public home after MSAL returns to `/`.
     * Do not use `history.replace("/")` while still authenticated: main `Switch` redirects `/` → account-owner offices.
     */
    postLogoutPublicNav: "mxhh-logout",
    /** Blocks client-side redirects while MSAL logoutRedirect is in flight. */
    logoutInProgress: "mxhh-logout-in-progress",
    /** Set before loginRedirect so App shows a loader instead of the public home shell. */
    pendingLoginRedirect: "mxhh-pending-login-redirect",
  },

  helpPages: {
    onlineHelp: [
      { id: "OnlineHelpForStaff", role: 3 },
      { id: "OnlineHelpForAccountOwner", role: 2 },
      { id: "OnlineHelpForPatient", role: 4 },
    ],

    Faq: [
      { id: "FAQForStaff", role: 3 },
      { id: "FAQForAccountOwner", role: 2 },
      { id: "FAQForPatient", role: 4 },
    ],
  },

  regex: {
    // eslint-disable-next-line
    validURL:
      /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
    validIP:
      /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    validSocialSecurityNumber: /^[a-zA-Z0-9]*$/,
  },

  deviceTypes: [
    {
      id: 1,
      title: "Android",
    },
    {
      id: 2,
      title: "iOS",
    },
  ],

  reportOptions: [
    {
      id: 1,
      title: "Offensive or harmful",
    },
    {
      id: 2,
      title: "Factually Incorect",
    },
    {
      id: 3,
      title: "Biased or inappropriate suggestion",
    },
    {
      id: 4,
      title: "Others",
    },
  ],

  sortOptions: [
    { id: "1", name: "Latest", sortBy: 3, sortDescending: true },
    { id: "2", name: "Document Name (A-Z)", sortBy: 1, sortDescending: false },
    { id: "3", name: "Document Name (Z-A)", sortBy: 1, sortDescending: true },
    { id: "4", name: "Category (A-Z)", sortBy: 2, sortDescending: false },
    { id: "5", name: "Category (Z-A)", sortBy: 2, sortDescending: true },
    { id: "6", name: "Uploaded On (Newest)", sortBy: 3, sortDescending: true },
    { id: "7", name: "Uploaded On (Oldest)", sortBy: 3, sortDescending: false },
    { id: "8", name: "Expiry On (Newest)", sortBy: 4, sortDescending: true },
    { id: "9", name: "Expiry On (Oldest)", sortBy: 4, sortDescending: false },
  ],

  fileTypes: [
    {
      id: 1,
      title: "PDF",
    },
    {
      id: 2,
      title: "DOCX",
    },
    {
      id: 3,
      title: "TXT",
    },
    {
      id: 4,
      title: "DOC",
    },
  ],

  notificationRedirectionCode: {
    eventAcceptAndReject: 136,
    eventJoinandInvite: 137,
    PulishEvent: 146,
    RequestToJoin: 144,
    EventEmployee: 145,
    EventRequestToJoin: 148,
    globalNotes: 121,
    globalNoteReminder: 120,
    cancaltask: 113,
    newComment: 119,
    newTaskassigned: 111,
    taskActions: 112,
    taskdelete: 126,
    ReviewSubmitted: 117,
    ReviewCompleted: 116,
    ReviewFinalized: 116,
    ReviewCancelled: 118,
    ReviewAssigned: 115,
    employmentProofRequest: 132,
    employementProofSubmitted: 133,
    notices: 114,
    newAppointmentRequest: 141,
    cancelAppointmentRequest: 142,
    busySlotDetail: 159,
    eventDetail: 145,
    eventDetailForAdmin: 212,
    timesheetViewDetail: 161,
    ownerleave: 203,
    staffLeave: 205,
    // /profile or when officeId present in object /credentials-licensing-global
    staffAndOfficeCredential: 160,
    officePolicyCancelView: 206,
    officePolicyCommentView: 207,
    officePolicyAssignedToYouView: 208,
    officePolicyAssignmentStatusUpdatedView: 209,
    officePolicyAssignmentDeleteView: 210,
  },

  appTypes: [
    {
      id: 1,
      title: "Personnel/Account Owner App",
    },
    {
      id: 2,
      title: "Patient App",
    },
    {
      id: 3,
      title: "Supply App",
    },
  ],

  timesheetStatuses: [
    {
      id: 1,
      title: "Pending",
    },
    {
      id: 2,
      title: "Waiting for Approval",
    },
    {
      id: 3,
      title: "Approved",
    },
    {
      id: 4,
      title: "Rejected",
    },
    {
      id: 5,
      title: "Paid",
    },
  ],
  leaveHoldiday: (t) => ({
    1: t("scheduler.onLeave"),
    2: t("scheduler.onHoliday"),
  }),
  SchedulerStatuses: [
    {
      id: 1,
      title: "pending",
    },
    {
      id: 2,
      title: "accepted",
    },
    {
      id: 3,
      title: "rejected",
    },
    {
      id: 4,
      title: "cancelled",
    },
  ],
  SchedulerStatuseWorkingEvents: [
    {
      id: 1,
      title: "Pending",
    },
    {
      id: 2,
      title: "Accepted",
    },
    {
      id: 3,
      title: "Rejected",
    },
  ],

  upComingAppointmentStatus: [
    {
      id: 1,
      title: "Pending",
    },
    {
      id: 2,
      title: "Accepted",
    },
    {
      id: 7,
      title: "Confirmed",
    },
  ],

  pastAppointmentStatus: [
    {
      id: 3,
      title: "Rejected",
    },
    {
      id: 4,
      title: "Cancelled",
    },
    {
      id: 5,
      title: "Completed",
    },
    {
      id: 6,
      title: "No Show",
    },
  ],

  recallAppointmentStatus: [
    {
      id: 8,
      title: "Overdue",
    },
    {
      id: 9,
      title: "Upcoming",
    },
    {
      id: 10,
      title: "Converted",
    },
  ],

  appointmentTimeTypes: {
    Morning: 1,
    Afternoon: 2,
    Evening: 3,
    Anytime: 4,
  },

  completedAppointmentDateTime: [
    {
      name: "Custom Date",
      id: 1,
    },
    {
      name: "1 Week After Completed Appointment",
      id: 7,
    },
    {
      name: "2 Week After Completed Appointment",
      id: 14,
    },
    {
      name: "3 Week After Completed Appointment",
      id: 21,
    },
    {
      name: "1 Month After Completed Appointment",
      id: 30,
    },
    {
      name: "2 Month After Completed Appointment",
      id: 60,
    },
    {
      name: "3 Month After Completed Appointment",
      id: 90,
    },
    {
      name: "1 Year After Completed Appointment",
      id: 365,
    },
  ],

  googleDoctorsStatusFilter: {
    All: 1,
    Pending: 2,
    Completed: 3,
  },

  agendaType: {
    APPOINTMENT: 1,
    LEAVE: 2,
    BUSY_SLOT: 3,
    EVENT: 4,
    BLOCKED: 5,
    PENDINGLEAVE: 1,
    APPROVEDLEAVE: 2,
  },

  appointmentStatus: {
    Pending: 1,
    Accepted: 2,
    Rejected: 3,
    Cancelled: 4,
    Completed: 5,
    NoShow: 6,
    Confirmed: 7,
    Overdue: 8,
    Upcoming: 9,
    Converted: 10,
  },

  agendaTitleLength: 80,

  SCHEDULERSTATUS: {
    PENDING: 1,
    ACCEPT: 2,
    REJECT: 3,
  },

  SCHEDULEREVENTTYPE: {
    All: "FOR_JOIN_ALL_FUTURE_EVENTS",
    SPECFIC: "FOR_JOIN_SPECFIC_EVENTS",
    SINGLEDAY: 1,
    SPECFICDATES: 4,
    AllWeekDay: 2,
    ACCEPT: "ACCEPT",
    REJECT: "REJECT",
    REASONOFREJECT: "REASONOFREJECT",
    inviteStaff: "invite",
  },
  titles: [
    {
      id: 2,
      text: "Mr.",
    },
    {
      id: 5,
      text: "Ms.",
    },
    {
      id: 1,
      text: "Dr.",
    },
    {
      id: 6,
      text: "None",
    },
  ],

  titleIds: {
    mr: 2,
    ms: 5,
    dr: 1,
  },

  animation: {
    hoverScale: 1.05,
  },

  lsKeys: {
    bookAppointmentData: "book_appointment_data",
    staffOnlineToast: "staffOnlineToast",
    OwnerOnlineToast: "OwnerOnlineToast",
  },
  containerName: {
    CONTAINER_NAME_CONTRACTS: "contracts",
    CONTAINER_NAME_CONTRACTS_SIGNATURE: "contract-signatures",
  },
  appLinks: {
    patientAndroidAppStoreLink:
      process.env.REACT_APP_PATIENT_ANDROID_APP_STORE_LINK,
    patientIosAppStoreLink: process.env.REACT_APP_PATIENT_IOS_APP_STORE_LINK,
  },

  sikkaMiraxisUrl: process.env.REACT_APP_SIKKA_MIRAXIS_URL || "",

  NOTIFICATIONREADED: "NOTIFICATIONREADED",
  NOTIFICATIONUNREAD: "NOTIFICATIONUNREAD",
  SUBSCRIPTIONMODULEADDED: "SUBSCRIPTIONMODULEADDED",
  SUBSCRIPTIONMODULEREMOVED: "SUBSCRIPTIONMODULEREMOVED",
  OWNERMESSAENGERMODULEADDED: "OWNERMESSAENGERMODULEADDED",
  OWNERMESSAENGERMODULEREMOVED: "OWNERMESSAENGERMODULEREMOVED",

  wordLimits: {
    REJECTOINREQUESTJOIN: 400,
    ADDOFFICEADDRESS: 150,
    STREETADDRESS: 100,
    SOCIALSECURITYNUMBERMAXLENGTH: 20,
  },

  MAPKEY: {
    COUNTRY: "country",
    ADMINISTRATIVE: "administrative_area_level_1",
    LOCALITY: "locality",
    POSTALCODE: "postal_code",
  },

  GOOGLEPLACETYPE: [
    "doctor",
    "dentist",
    "hospital",
    "pharmacy",
    "physiotherapist",
  ],
  INITIAL_GOOGLE_RADIUS: 10000,
  EXTENDED_GOOGLE_RADIUS: 20000,
  COUNTRY: {
    US: "US",
    CA: "CA",
    USLATLNG: { lat: 38.34, lng: -100.69 },
    CALATLNG: { lat: 57.89, lng: -101.61 },
    CABOUNDS: {
      north: 83.23324,
      south: 41.6751050889,
      west: -140.99778,
      east: -52.6480987209,
    },
    USBOUNDS: {
      north: 71.3577635769,
      south: 18.91619,
      west: -171.791110603,
      east: -66.96466,
    },
  },
  NOTINGOOGLE: "NOTINGOOGLE",
  ADDOFFICEADDRESS: 150,
  messageLimit: 400,

  JOBTYPE: {
    Temporary: 1,
    Permanent: 2,
  },

  DOWNLOADLINK: {
    playStore:
      "https://play.google.com/store/apps/details?id=com.miraxis.healthhubapp&hl=en_IN&gl=US",
    appStore: "https://apps.apple.com/in/app/miraxis-healthhub/id1548418438",
  },
  DOWNLOADLINKFORPATIENT: {
    playStore:
      "https://play.google.com/store/apps/details?id=com.miraxis.healthhubpatientapp",
    appStore: "https://apps.apple.com/be/app/miraxis-patients/id1614384418",
  },
  DOWNLOADLINKFORSUPPLY: {
    playStore:
      "https://play.google.com/store/apps/details?id=com.miraxis.healthhubsupply",
    appStore: "https://apps.apple.com/us/app/miraxis-supply/id6451264069",
  },
  weekday: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],

  chat: {
    internal: "internal",
    external: "external",
    patientChat: "patient",
    teamLiveChat: "team_live",
    patient: {
      open: "PATIENT_MESSENGER_OPEN_CHAT",
      close: "PATIENT_MESSENGER_CLOSE_CHAT",
    },
    unArchived: "unhidden_only",
    archived: "hidden_only",
    latestLastMessage: "latest_last_message",
    chatListLimit: 100,
    chatGroupImageSizeInMbs: 10,
    ALL_OFFICES: 0,
    /** Sentinel for team chat role filter ("all roles") — same numeric convention as offices. */
    ALL_ROLES: 0,
    externalChatTitleLength: 120,
    groupNameLimit: 100,
    acceptForGroupImage: ".jpg,.jpeg,.png",
    acceptForMessageInput:
      ".jpg,.jpeg,.png,.pdf,.txt,.csv,.doc,.docx,.xls,.xlsx",
    allowedTypesForGroupImage: ["image/png", "image/jpg", "image/jpeg"],
    allowedTypesForMessage: [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "text/csv",
      "text/plain",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    allowedTypesForImageDocsAndPdf: [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ],
    allowedTypesForDocs: [
      "text/csv",
      "text/plain",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
  },
  contracts: {
    contractslocalstorageKey: "contractDetails",
  },
  vendor: {
    step: {
      addProfileDetails: "1",
      purchaseSubscription: "2",
      addCardDetails: "3",
      bankDetails: "4",
      completed: "completed",
    },
    productDetails: "product-details",
    productImageContainer: "product-images",
    acceptForProductImage: ".jpg,.jpeg,.png",
    productImageSizeInMbs: 5,
    allowedTypesForProductImage: ["image/png", "image/jpg", "image/jpeg"],
    cache: {
      salesRepList: "sales-rep-list-cache",
      catalogueList: "catalogue-list-cache",
      salesRepDetail: "sales-rep-detail-cache",
      manageOrderslisting: "manage-orders-listing-cache",
      promoCodesList: "promo-codes-list-cache",
      editingValue: "editing-value",
      manageOrders: "Manage_Orders",
      manageSalesRepAdmin: "Manage_Sales_Rep_Admin",
      orderDetail: "order-detail-cache",
      salesRepVendorInAdmin: "sales-rep-cache-in-venodr-admin",
      orderDetailsTabs: "order-details-tab-in-venodr-admin",
      orderHistoryFilter: "order-history-filter-cache",
      customerOrderList: "customer-order-list-cache",
      manageCustomersList: "manage-customers-list-cache",
      manageCommissionsCache: "Manage_Commissions_cache",
      supportHelpVendorCache: "Support_help_vendor-cache",
      superAdminTopUp: "super-admin-top-up-promotion-cache",
      promotionTabCache: "promotion-tab-cache",
      promotionPaginationCache: "promotion-tab-pagination-cache",
      vendorDashBoardDateCache: "Vendor-dashboard-date-cache",
      vendorInvoiceCache: "Vendor-Invoice-Cache",
      vendorEnterpriceCache: "Vendor-Enterprice-Cache",
      vendorEnterPriceAssignCache: "Vendor-Enterprice-Assign-Cache",
    },
    enums: {
      orderStatus: {
        all: 0,
        pending: 1,
        accepted: 2,
        shipped: 4,
        partiallyShipped: 5,
        delivered: 6,
        cancelled: 7,
        list: [
          { name: "All", id: null },
          { name: "Pending", id: 1 },
          { name: "Accepted", id: 2 },
          { name: "Partially Accepted", id: 3 },
          { name: "Shipped", id: 4 },
          { name: "Partially Shipped", id: 5 },
          { name: "Delivered", id: 6 },
          { name: "Cancelled", id: 7 },
        ],
      },
      paymentMethod: {
        billMeLater: 1,
        paidOnline: 2,
        list: [
          { id: null, name: "All" },
          { id: 1, name: "Bill Me Later" },
          { id: 2, name: "Online by Credit Card" },
        ],
      },
      paymentStatus: {
        notPaid: 1,
        paid: 2,
        list: [
          { id: null, name: "All" },
          { id: 1, name: "Not Paid" },
          { id: 2, name: "Paid" },
        ],
      },
    },
  },

  arrow: {
    NEXT: 1,
    PREVIOUS: 2,
  },

  PopUp: {
    innerPopUp: 1,
    outerPopUp: 2,
  },
  staffAvalibility: "staffAvalibility",
  staffAvalibilityDate: "staffAvalibilityDateKey",
  EVENT_DATE_SESSION_KEY: "Event_DATE_KEY",
  EVENT_OFFICE_FILTER: "EVENT_OFFICE_FILTER",
  EVENT_DISPLAY_SETTINGS: "EVENT_DISPLAY_SETTINGS",
  EVENT_TYPE_SESSION_KEY: "Event_TYPE_KEY",
  EVENT_WEEKLY_LAYOUT_SESSION_KEY: "Event_WEEKLY_LAYOUT_KEY",
  EVENT_WEEKLY_SORT_SESSION_KEY: "Event_WEEKLY_SORT_KEY",
  SCHEDULER_INVITATION_REQUEST_OFFICES: "SCHEDULER_INVITATION_REQUEST_OFFICES",
  SCHEDULER_INVITATION_REQUEST_STATUS: "SCHEDULER_INVITATION_REQUEST_STATUS",
  SCHEDULER_EVENT_SHIT_STATUS: "SCHEDULER_EVENT_SHIT_STATUS",
  MY_SCHEDULER_EVENT_DATE: "selectedDate",
  dashboardSchedularView: "dashboardSchedularView",
  ticketStatus: {
    resolved: 3,
    progress: 2,
    pending: 1,
  },
  calanderActions: ["next", "next2", "prev", "prev2"],
  calanderActionKey: {
    drillDown: "drillDown",
    year: "year",
  },
  cmsPageKey: {
    TermsAndConditions: "TermsAndConditions",
    PrivacyPolicy: "PrivacyPolicy",
    AboutUs: "AboutUs",
    Testimonials: " Testimonials",
    ContactUs: "ContactUs",
    Email: "Email",
    Phone: "Phone",
    Address: "Address",
    TermsAndConditionForContractTemplate:
      "TermsAndConditionForContractTemplate",
    TermsAndConditionOfContractForStaff: "TermsAndConditionOfContractForStaff",
    TermsAndConditionsForPatient: "TermsAndConditionsForPatient",
    PrivacyPolicyForPatient: "PrivacyPolicyForPatient",
    TermsAndConditionsForVendor: "TermsAndConditionsForVendor",
    PrivacyPolicyForVendor: "PrivacyPolicyForVendor",
    FAQForAccountOwner: "FAQForAccountOwner",
    OnlineHelpForPatient: "OnlineHelpForPatient",
    OnlineHelpForAccountOwner: "OnlineHelpForAccountOwner",
    OnlineHelpForStaff: "OnlineHelpForStaff",
    FAQForPatient: "FAQForPatient",
    FAQForStaff: "FAQForStaff",
    OurMission: "OurMission",
  },
  requestEventStatus: {
    Pending: 1,
    Accepted: 2,
    Reject: 3,
    Cancel: 4,
  },
  OnlineFaqPages: [
    "/owner/faq",
    "/patient/faq",
    "/staff/faq",
    "/owner/help",
    "/patient/help",
    "/staff/help",
    "/blogs/9-reasons-why-dentists-are-automating-their-practice",
    "/blogs/top-9-ways-for-you-and-your-staff-to-avoid-burnout",
    "/blogs/top-9-benefits-of-streamlining-and-automating-workflows-in-your-dental-practice",
    "/blogs/communication-with-your-team-how-to-be-hands-offand-still-be-hands-on",
    "/blogs/3-effective-ways-technology-can-help-you-efficiently-manage-staff-in-your-practice",
    "/blogs/8-ways-leading-dental-practices-enhance-their-staff-experience",
    "/blogs/6-ways-to-recruit-and-retain-practice-employees",
    "/landing-pages/guide-download-page",
    "/landing-pages/guide-thank-page",
    "/landing-pages/ebook-download-page",
    "/landing-pages/ebook-thank-page",
    "/getstarted",
    "/landing-pages/guide-download-page-fb",
    "/landing-pages/guide-download-page-ggl",
    "/landing-pages/guide-download-page-sm",
    "/landing-pages/ebook-download-page-fb",
    "/landing-pages/ebook-download-page-ggl",
    "/landing-pages/ebook-download-page-sm",
    "/demo-request-page",
    "/demo-request-thank-page",
  ],
  faqRequestType: {
    HelpGuideRequest: 1,
    ChecklistRequest: 2,
  },
  categoryType: {
    add: 1,
    edit: 2,
  },
  selectType: {
    selectAll: 1,
    selectQuantity: 2,
  },
  taxTypeModal: {
    add: 1,
    edit: 2,
  },
  taxType: {
    oneTax: 1,
    ProvienceTax: 2,
  },

  orderStatus: {
    all: 0,
    Pending: 1,
    Accepted: 2,
    PartiallyAccepted: 3,
    Shipped: 4,
    PartiallyShipped: 5,
    Delivered: 6,
    Cancelled: 7,
    UnPaid: 8,

    newShipment: true,
  },

  orderStatusTitle: [
    {
      title: "Pending",
      value: 1,
    },
    {
      title: "Accepted",
      alt: "Not Shipped",
      value: 2,
    },
    {
      title: "Partially Accepted",
      value: 3,
    },
    {
      title: "Shipped",
      value: 4,
    },
    {
      title: "Partially Shipped",
      value: 5,
    },
    {
      title: "Delivered",
      value: 6,
    },
    {
      title: "Cancelled",
      value: 7,
    },
  ],

  paymentMethod: [
    { value: 1, title: "Bill Me Later" },
    { value: 2, title: "Online by Credit Card" },
  ],

  paymentStatus: [
    { value: 1, title: "Not Paid" },
    { value: 2, title: "Paid" },
  ],

  paymentStatusObj: {
    paid: 2,
    notPaid: 2,
  },

  paymentMethodObj: {
    billMeLater: 1,
    paid: 2,
  },

  orderDetails: {
    ACCEPT: "ACCEPT",
    DECLINE: "DECLINE",
    AcceptPartially: "ACCEPTPARTIALLY",
  },
  vendorDetailsTab: {
    orderHistory: "1",
    salesRep: "2",
  },

  hubspotFormPages: {
    ebookDownloadPage: "ebookDownloadPage",
    fbHubspotPage: "fbHubspotPage",
    gglHubspotPage: "gglHubspotPage",
    smHubspotPage: "smHubspotPage",
    guideDownloadPage: "guideDownloadPage",
    fbGuideHubspotPage: "fbGuideHubspotPage",
    gglGuideHubspotPage: "gglGuideHubspotPage",
    smGuideHubspotPage: "smGuideHubspotPage",
  },
  vendorTicketType: [
    {
      value: null,
      label: "All Tickets",
      class: "",
    },
    {
      value: 1,
      label: "Pending",
      class: "pending",
    },
    {
      value: 2,
      label: "In Progress",
      class: "inProgress",
    },
    {
      value: 3,
      label: "Resolved",
      class: "resolved",
    },
  ],

  genderOptions: [
    { name: "Male", id: 1 },
    { name: "Female", id: 2 },
    { name: "Other", id: 3 },
  ],

  relationOptions: [
    { name: "Father ", id: 1 },
    { name: "Mother", id: 2 },
    { name: "Daughter", id: 3 },
    { name: "Son", id: 4 },
    { name: "Husband", id: 5 },
    { name: "Wife", id: 6 },
    { name: "Others", id: 7 },
  ],

  notes: {
    addFormKeys: {
      assignTo: {
        self: "self",
        staff: "staff",
      },
    },
    cache: {
      Noteslisting: "notes-listing-cache",
      archivedListing: "archived-listing-cache",
      myNotesFilter: "my-notes-filter-cache",
      transferedNoteFilter: "transferred-notes-filter-cache",
      dashboardFilter: "dash-board-filter-cache",
      dashboardAccountOwnerCheck: "dashboard-account-owner-check",
      isMySchedule: "dashboard-isMySchedule",
      myScheduleView: "dashboard-myScheduleView",
      otherScheduleView: "dashboard-otherScheduleView",
      isChatFromDashBoard: "isChatFromDashBoard",
      timeSheetSelectedDateRange: "timeSheetSelectedDateRange",
      isFromStaffAdmin: "isFromStaffAdmin",
      officeStaffInformation: "officeStaffInformation",
      globalOfficeStaffInformationTabs: "globalOfficeStaffInformation",
    },
  },
  waitingList: {
    cache: {
      filters: "waiting-list-filter-cache",
    },
  },
  manageDashboardList: {
    cache: {
      requestApprovalCache: "request-approval-cache",
      dashboardChatCache: "dashboard-chat-cache",
      dashboardTeamChatCache: "dashboard-team-chat-cache",
    },
  },
  scheduler: {
    cache: {
      ownerKey: "selectedOwner",
    },
  },
  appointmentList: {
    cache: {
      upCommingfilters: "appointment-list-upComingfilter-cache",
      recallfilters: "appointment-list-recallfilter-cache",
      pastfilters: "appointment-list-pastfilter-cache",
      todaysFilter: "appointment-list-todaysfilter-cache",
      isTabClicked: "isClicked",
    },
  },

  patientsList: {
    cache: {
      filters: "patients-list-filter-cache",
      patientList: "patient-list-cache",
      patientListMessageHistory: "patient-list-message-history",
    },
  },

  performanceReview: {
    cache: {
      performanceReviewlisting: "performance-review-listing-cache",
      performanceArchivedListing: "performance-archived-listing-cache",
      performanceReviewFilter: "performance-review-filter",
    },
  },

  employementProof: {
    cache: {
      employementProofList: "employement-proof-listing-cache",
    },
  },

  notesTabStatus: {
    myNote: 1,
    transfferedNote: 2,
  },
  officeStaffInformation: {
    office: 1,
    ownerManager: 2,
    staff: 3,
  },

  requestApprovalTabStatus: {
    requestsInvitations: 1,
    Notifications: 2,
  },

  employementProofTab: {
    ongoing: 1,
    archived: 2,
  },

  performanceReviewTab: {
    initiatedByYou: 1,
    initiatedByAdmin: 2,
  },

  patientAppointMentTab: {
    upCommingAppointment: 1,
    recallAppointment: 2,
    pastAppointment: 3,
  },

  patientScheduling: {
    cache: {
      eventlisting: "event-listing-cache",
    },
  },

  patientsTab: {
    myPatients: 1,
    otherDoctors: 2,
  },

  familyMembers: {
    cache: {
      familyMemberlisting: "family-member-listing-cache",
      familyMemberAddedYoulisting: "family-member-listing-cache",
      selectedMemberData: "selected-member-data",
    },
    inviteStatus: {
      Pending: 1,
      Accepted: 2,
      Rejected: 3,
      NotRegister: 4,
    },
  },

  familyMemberTabStatus: {
    addedMembers: 1,
    membersAddedYou: 2,
  },

  subscriptionType: {
    basic: 1,
    advanced: 2,
    professional: 3,
    free: 4,
    trial: 5,
    enterprise: 6,
  },
  subscriptionTypesArray: [1, 2, 3],
  sessionStoragecache: {
    subscriptionDetails: "subscription-plan-Details-cache-tab",
    officeKey: "OFFFICE_KEY_CACHE",
    ownerEnterPriseListng: "owner-EnterPrise-Listng-cache",
  },

  subscriptionModuleType: {
    Default: 1,
    LinkedWithFeature: 2,
    Textual: 3,
  },

  OfficeTimesheetStatus: [
    {
      value: null,
      label: "All",
    },
    {
      value: 1,
      label: "Pending For Approval",
    },
    {
      value: 2,
      label: "Approved",
    },
    {
      value: 3,
      label: "Rejected",
    },
    {
      value: 4,
      label: "Partially Paid",
    },
    {
      value: 5,
      label: "Paid",
    },
    {
      value: 6,
      label: "Pending",
    },
  ],

  TimesheetListingStatus: [
    {
      value: null,
      label: "All",
    },
    {
      value: 2,
      label: "Pending For Approval",
    },
    {
      value: 3,
      label: "Approved",
    },
    {
      value: 4,
      label: "Rejected",
    },
    {
      value: 5,
      label: "Paid",
    },
  ],

  TimesheetType: {
    AllDay: 1,
    Hourly: 2,
  },

  Timesheet: {
    cache: {
      staffMemberTimesheetlisting: "staff-member-timesheet-listing-cache",
      timesheetListingCache: "timesheet-listing-cache",
      timesheetReportCache: "timesheet-report-cache",
      staffTimesheetDetailListing: "staff-timesheet-detail-listing",
    },
  },

  LeaveStatus: [
    {
      value: null,
      label: "All",
    },
    {
      value: 1,
      label: "Pending",
    },
    {
      value: 2,
      label: "Approved",
    },
    {
      value: 3,
      label: "Rejected",
    },
    {
      value: 4,
      label: "Withdrawn",
    },
    {
      value: 5,
      label: "Cancel",
    },
    {
      value: 6,
      label: "CancellationPending",
    },
    {
      value: 7,
      label: "Archived",
    },
  ],

  statusLabelMap: {
    1: "Pending",
    2: "Approved",
    3: "Rejected",
    4: "Withdrawn",
    5: "Cancelled",
    6: "Cancellation Pending",
    7: "Archived",
  },

  LeaveTypeStatus: [
    {
      value: null,
      label: "All",
    },
    {
      value: 1,
      label: "Casual",
    },
    {
      value: 2,
      label: "Medical",
    },
    {
      value: 3,
      label: "Vacation",
    },
  ],

  Leave: {
    cache: {
      staffLeavelisting: "staff-leave-listing-cache",
      leaveListing: "leave-listing-cache",
    },
  },

  leavesAndTimesheet: {
    cache: {
      list: "list-leaves-and-timesheet",
    },
  },

  pmsMembers: {
    cache: {
      pmsMemberlisting: "pms-member-listing-cache",
      pmsDoctorslisting: "pms-doctors-listing-cache",
      pmsPatientslisting: "pms-patients-listing-cache",
    },
  },

  aiSettings: {
    cache: {
      reviewRatinglisting: "review-rating-listing-cache",
      reviewRatingOngoinglisting: "review-rating-ongoing-listing-cache",
      reviewRatingArchivelisting: "review-rating-archive-listing-cache",
    },
  },

  messageTemplates: {
    cache: {
      list: "message-templates-list-cache",
    },
  },

  pmsMemberTabStatus: {
    doctors: 1,
    patients: 2,
  },

  reviewRatingTabStatus: {
    ongoing: 1,
    archive: 2,
  },

  yellowBarState: {
    active: "showYellowBar",
  },

  SikkaUserInvitationStatus: {
    new: 1,
    inviteSent: 2,
  },

  WeekDays: [
    {
      id: 7,
      day: " Sun ",
    },
    {
      id: 1,
      day: " Mon ",
    },
    {
      id: 2,
      day: " Tue ",
    },
    {
      id: 3,
      day: " Wed ",
    },
    {
      id: 4,
      day: " Thu ",
    },
    {
      id: 5,
      day: " Fri ",
    },
    {
      id: 6,
      day: " Sat ",
    },
  ],

  subscriptionPlan: [
    { value: 1, name: "Basic" },
    { value: 2, name: "Advanced" },
    { value: 3, name: "Professional" },
    { value: 4, name: "Free" },
    { value: 5, name: "Trial" },
    { value: 6, name: "Enterprise " },
  ],

  currenyArray: [
    { value: 1, name: "CAD" },
    { value: 2, name: "USD" },
  ],

  confirmedThrough: {
    email: 1,
    sms: 2,
    mobile: 3,
  },

  curreny: {
    CAD: 1,
    USD: 2,
  },
  radioTypeSubscription: {
    SINGLE: 1,
    MULTIPLE: 2,
  },
  moduleNameWithId: {
    formAndContracts: 15,
    teamLiveChat: 11,
    scheduler: 9,
    patientLiveChat: 22,
    taskManagement: 10,
    notesAndReminder: 12,
    patientConversation: 22,
    patientAppointment: 2,
  },
  ModuleIds: {
    17: "isNoticiesFeatureEnabled",
    10: "isTaskFeatureEnabled",
    12: "isNotesAndReminderFeatureEnabled",
    16: "isPerformanceReviewFeatureEnabled",
    18: "isDiscussionNotesFeatureEnabled",
    21: "isPatientAppointmentFeatureEnabled",
    22: "isPatientConversationFeatureEnabled",
    9: "isSchedulerFeatureEnabled",
    11: "isTeamConversationFeatureEnabled",
  },
  pageSize: 10,
  tasks: {
    cache: {
      taskslisting: "tasks-listing-cache",
      accountownercheck: "account-owner-check",
      myTaskFilter: "my-tasks-filter-cache",
      staffTaskFilter: "staff-tasks-filter-cache",
      archivedListing: "archived-task-listing",
      tasksIsSidebarActive: "tasks-isSidebarActive",
    },
  },
  officePolicies: {
    cache: {
      officePolicieslisting: "office-policies-listing-cache",
      accountownercheck: "account-owner-check",
      myOfficePolicyFilter: "my-office-policy-filter-cache",
      staffOfficePolicyFilter: "staff-office-policy-filter-cache",
      archivedListing: "archived-office-policy-listing",
      officePoliciesIsSidebarActive: "office-policies-isSidebarActive",
      officePolicyMainTab: "office-policy-main-tab",
      officePolicyComplianceSub: "office-policy-compliance-sub",
      officePolicyStaffSub: "office-policy-staff-sub",
      officePolicyAssignmentView: "office-policy-assignment-view",
    },
  },
  sidebar: {
    cache: {
      tasksIsSidebarActive: "tasks-isSidebarActive",
      officePoliciesIsSidebarActive: "office-policies-isSidebarActive",
      notesIsSidebarActive: "notes-isSidebarActive",
      appointmentIsSidebarActive: "appointment-isSidebarActive",
      schedulerIsSidebarActive: "scheduler-isSidebarActive",
      dashboardIsSidebarActive: "dashboard-isSidebarActive",
      performanceReviewIsSidebarActive: "performance-review-isSidebarActive",
      patientsIsSidebarActive: "patients-isSidebarActive",
      waitinglistIsSidebarActive: "waiting-list-isSidebarActive",
      teamChatIsSidebarActive: "team-chat-isSidebarActive",
      patientChatIsSidebarActive: "patient-chat-isSidebarActive",
      complianceAnalyticsIsSidebarActive:
        "compliance-analytics-isSidebarActive",
    },
  },
  accordion: {
    cache: {
      schedulerOfficeStaffAccordion: "scheduler-office-staff-accordion",
      schedulerOfficeEventAccordion: "scheduler-office-event-accordion",
      schedulermyScheduleEventAccordion:
        "scheduler-my-schedule-event-accordion",
      schedulermyScheduleInvitationAccordion:
        "scheduler-my-schedule-invitation-accordion",
      schedulermyScheduleShiftAccordion:
        "scheduler-my-schedule-shift-accordion",
      patientAppointmentAccordion: {
        storageKey: "patient-appointment-accordion",
        upcoming: "upcoming",
        recall: "recall",
        past: "past",
        seeToday: "seeToday",
      },
      staffListing: "staff-listing",
      staffListingAccordion: "staff-listing-accordion",
      globalStaffListing: "global-staff-listing",
      globalStaffListingAccordion: "global-staff-listing-accordion",
    },
  },
  fiscalYearOptions: [
    "January - December",
    "February - January",
    "March - February",
    "April - March",
    "May - April",
    "June - May",
    "July - June",
    "August - September",
    "September - August",
    "October - September",
    "November - October",
    "December - November",
  ],
  monthToNumber: {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  },
  addNewPolicyLimits: {
    TITLE_MAX_LENGTH: 200,
    DOCUMENT_NAME_MAX: 200,
    DESCRIPTION_MAX: 200,
    NOTES_MAX: 500,
    VERSION_MAX: 10,
    MAX_FILES: 50,
    MAX_FILE_SIZE_BYTES: 5 * 1024 * 1024,
    MAX_URLS: 10,
    OFFICE_DISPLAY_COUNT: 3,
    PRIORITY_LOW: 3,
    PRIORITY_MEDIUM: 2,
    PRIORITY_HIGH: 1,
    REMIND_DAYS: [1, 2, 3, 4, 5],
    URL_REGEX: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i,
  },
};

export const PERFORMANCE_REVIEW_FORM_TYPES = [
  "general",
  "probationPeriod",
  "monthlyReview",
  "quarterlyReview",
  "yearlyReview",
  "others",
];

export const PERFORMANCE_REVIEW_STATUS = [
  {
    id: 1,
    title: "pending",
  },
  {
    id: 2,
    title: "submitted",
  },
  {
    id: 3,
    title: "completed",
  },
  {
    id: 4,
    title: "cancelled",
  },
  {
    id: 5,
    title: "finalized",
  },
];

export const ReviewStatus = {
  pending: 1,
  submitted: 2,
  completed: 3,
  cancelled: 4,
  finalized: 5,
};

/**
 * Credential / Expiry Status API values.
 * Current = 1, Expiring Soon = 2, Expired = 3, No Expiry = 4, Expiry Unknown = 5
 */
export const CREDENTIAL_STATUS = {
  CURRENT: 1,
  EXPIRING_SOON: 2,
  EXPIRED: 3,
  NO_EXPIRY: 4,
  EXPIRY_UNKNOWN: 5,
};

export const AppointmentReminderTypeOptions = {
  KEY_NAME_ONE: "waiting-reminder",
  KEY_NAME_TWO: "acceptance-reminder",
  KEY_NAME_THREE: "complete-reminder",
  KEY_NAME_FOUR: "add-new-appointment",
};

export const notifyAttendeesOptions = [
  {
    id: 5,
    name: "5 minutes",
  },
  {
    id: 10,
    name: "10 minutes",
  },
  {
    id: 15,
    name: "15 minutes",
  },
  {
    id: 20,
    name: "20 minutes",
  },
  {
    id: 30,
    name: "30 minutes",
  },
  {
    id: 60,
    name: "1 hour",
  },
  {
    id: 120,
    name: "2 hours",
  },
  {
    id: 180,
    name: "3 hours",
  },
  {
    id: 240,
    name: "4 hours",
  },
  {
    id: 300,
    name: "5 hours",
  },
  {
    id: 360,
    name: "6 hours",
  },
  {
    id: 1440,
    name: "1 day",
  },
  {
    id: 2880,
    name: "2 days",
  },
  {
    id: 4320,
    name: "3 days",
  },
  {
    id: 5760,
    name: "4 days",
  },
  {
    id: 10080,
    name: "1 week",
  },
  {
    id: 0,
    name: "Do not notify",
  },
];

export const notifyAttendeesOptionsForAllDayEvent = (isShift) => [
  {
    id: -420,
    name: `07:00 AM on the day of the ${isShift ? "shift" : "event"}`,
  },
  {
    id: -480,
    name: `08:00 AM on the day of the ${isShift ? "shift" : "event"}`,
  },
  {
    id: -540,
    name: `09:00 AM on the day of the ${isShift ? "shift" : "event"}`,
  },
  {
    id: 1440,
    name: "1 day",
  },
  {
    id: 2880,
    name: "2 days",
  },
  {
    id: 4320,
    name: "3 days",
  },
  {
    id: 5760,
    name: "4 days",
  },
  {
    id: 10080,
    name: "1 week",
  },
  {
    id: 0,
    name: "Do not notify",
  },
];

export const isModuleAccessable = (arrayOfModules, currentModuleId) => {
  try {
    if (Array.isArray(arrayOfModules) && arrayOfModules.length) {
      let module = arrayOfModules.find((item) => item.id === currentModuleId);
      if (module) {
        return module?.isAvailable;
      }
    }
    return false;
  } catch {}
};

export function getcurreny(id) {
  let currency = constants.currenyArray.find((item) => item.value == id)?.name;
  return currency ? currency : "--";
}

export function getsubcriptionPlanTitle(id) {
  let subName = constants.subscriptionPlan.find(
    (item) => item.value == id,
  )?.name;
  return subName ? subName : "--";
}

export function getDeviceTypeById(deviceTypeId) {
  let deviceType = constants.deviceTypes.find((it) => it.id === deviceTypeId);
  return deviceType === undefined ? { id: 0, title: "Unknown" } : deviceType;
}

export function getAppTypeById(appTypeId) {
  let appType = constants.appTypes.find((it) => it.id === appTypeId);
  return appType === undefined ? { id: 0, title: "Unknown" } : appType;
}

export function getTimesheetStatusById(timesheetStatusId) {
  const timesheetStatus = constants.timesheetStatuses.find(
    (it) => it.id === timesheetStatusId,
  );
  return timesheetStatus === undefined
    ? { id: 0, title: "Unknown" }
    : timesheetStatus;
}

export function getSchedulerStatusById(schedulerStatusId) {
  const schedulerStatus = constants.SchedulerStatuses.find(
    (it) => it.id === schedulerStatusId,
  );
  return schedulerStatus === undefined
    ? { id: 0, title: "Unknown" }
    : schedulerStatus.title;
}

export const orderStatus = (statusId, alt = false) => {
  const status = constants.orderStatusTitle.find(
    (orderStatusTitle) => orderStatusTitle.value === statusId,
  );
  if (status) {
    return alt ? status?.alt : status?.title;
  }

  return "Unknown";
};

export const paymentMethodStatus = (paymentMethodId) => {
  const status = constants.paymentMethod.find(
    (paymentMethod) => paymentMethod.value === paymentMethodId,
  );
  if (status) {
    return status?.title;
  }

  return "Unknown";
};

export const paymentStatus = (paymentMethodId) => {
  const status = constants.paymentStatus.find(
    (item) => item.value === paymentMethodId,
  );
  if (status) {
    return status?.title;
  }

  return "Unknown";
};

export const getClassNameVenodorTicket = (ticketStatus) => {
  let className = constants.vendorTicketType.find(
    (item) => item.value === ticketStatus,
  )?.class;
  if (className) return className;
  else return "";
};

export const getStatusVenodorTicket = (ticketStatus) => {
  let className = constants.vendorTicketType.find(
    (item) => item.value === ticketStatus,
  )?.label;
  if (className) return className;
  else return "--";
};

export const getKeyValueFromList = (list, id, key) => {
  const status = list.find((item) => item.id === id);
  if (status) {
    return status?.[key];
  }

  return "--";
};

/**
 * Gets the notification name from the array based on the provided time in minutes
 * @param {number} timeInMinutes - The time value in minutes to look up
 * @param {Array} optionsArray - The array of notification options to search in
 * @returns {string} - The name of the matching notification option or "Unknown notification time" if not found
 */
export const getNotificationNameById = (timeInMinutes, optionsArray) => {
  const option = optionsArray.find((item) => item.id === timeInMinutes);
  return option ? option.name : "--";
};

export const taskStatusOptions = [
  {
    value: "",
    label: "All Tasks",
  },
  {
    value: 1,
    label: "In Progress",
  },
  {
    value: 2,
    label: "Pending",
  },
  {
    value: 3,
    label: "Accepted",
  },
  {
    value: 4,
    label: "Started",
  },
  {
    value: 5,
    label: "Completed",
  },
  {
    value: 6,
    label: "Rejected",
  },
  {
    value: 7,
    label: "Cancelled",
  },
];

/** Assignment status IDs for policy assignees (used in AssigneeCard, overdue checks). */
export const officePolicyAssignmentStatus = {
  IN_PROGRESS: 1,
  PENDING: 2,
  ACCEPTED: 3,
  STARTED: 4,
  COMPLETED: 5,
  REJECTED: 6,
  CANCELLED: 7,
  DRAFT: 8,
  OVERDUE: 9,
};

/** Filter options for Staff Tracking status selection. */
export const staffTrackingStatusOptions = [
  { id: 2, name: "Pending", uniqueKey: uuidv4() },
  {
    id: 3,
    name: "Accepted",
    uniqueKey: uuidv4(),
  },
  { id: 4, name: "Started", uniqueKey: uuidv4() },
  {
    id: 5,
    name: "Completed",
    uniqueKey: uuidv4(),
  },
  {
    id: 7,
    name: "Cancelled",
    uniqueKey: uuidv4(),
  },
  {
    id: 8,
    name: "Overdue",
    uniqueKey: uuidv4(),
  },
];

export const officePolicyStatusOptions = [
  {
    value: "",
    label: "All Policies",
    uniqueKey: uuidv4(),
  },
  {
    value: 1,
    label: "In Progress",
    uniqueKey: uuidv4(),
  },
  {
    value: 2,
    label: "Pending",
    uniqueKey: uuidv4(),
  },
  {
    value: 3,
    label: "Accepted",
    uniqueKey: uuidv4(),
  },
  {
    value: 4,
    label: "Started",
    uniqueKey: uuidv4(),
  },
  {
    value: 5,
    label: "Completed",
    uniqueKey: uuidv4(),
  },
  {
    value: 7,
    label: "Cancelled",
    uniqueKey: uuidv4(),
  },
  {
    value: 8,
    label: "Draft",
    uniqueKey: uuidv4(),
  },
  {
    value: 9,
    label: "Overdue",
    uniqueKey: uuidv4(),
  },
];

export const prioritiesOptions = [
  { id: 3, name: "Low" },
  { id: 2, name: "Medium" },
  { id: 1, name: "High" },
];

export const policyFolderSortOptions = [
  { id: 3, name: "All" },
  { id: 1, name: "Due: Today" },
  { id: 2, name: "Due: This week" },
];

export const sortByOptions = [
  {
    value: 3,
    label: "Last Updated",
    className: "last-updated-option",
  },
  {
    value: 2,
    label: "Creation Date",
    className: "creation-date-option",
  },
  {
    value: 1,
    label: "Due Date",
    className: "due-date-option",
  },
];

export const taskTabStatus = {
  assigntoMe: 1,
  assignedByMe: 2,
};

export const officePolicyTabStatus = {
  assigntoMe: 1,
  assignedByMe: 2,
};

export const eventSchedulingTabStatus = {
  event: 1,
  schedulingAssistant: 2,
};
export const reasonsList = [
  { value: 1, label: "Absenteeism/Insubordination" },
  { value: 2, label: "Tardiness" },
  { value: 3, label: "PolicyOrProcedureViolation" },
  { value: 4, label: "Behavorial" },
  { value: "others", label: "Others" },
];

export const Daysarray = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const PofileColors = [
  "#8C0346",
  "#367B60",
  "#6E2995",
  "#42738C",
  "#220953",
  "#96731A",
  "#606015",
  "#1338AB",
  "#293E39",
  "#B55234",
  "#411F10",
  "#055989",
  "#523C94",
  "#708909",
  "#B53389",
  "#BE1F35",
  "#7666C6",
  "#405D73",
  "#3F3F41",
  "#786F80",
];

export const REVEIWQUESTIONLIST = [
  {
    id: 6346,
    question: {
      id: 1,
      questionTitle: "Job Knowledge & Technical Skills",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 1,
        ratingValue: 1,
        ratingDescription:
          "Has difficulty understanding work duties and/or computer systems.",
      },
      {
        id: 2,
        ratingValue: 2,
        ratingDescription:
          "Needs to increase knowledge of some phases of work and/or computer system.",
      },
      {
        id: 3,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements. Actively upgrades application of skills and knowledge.",
      },
      {
        id: 4,
        ratingValue: 4,
        ratingDescription:
          "Better than average skills. Understands job and technical skills required.",
      },
      {
        id: 5,
        ratingValue: 5,
        ratingDescription:
          "Excellent.  Has complete mastery of all phases of job.",
      },
    ],
  },
  {
    id: 6347,
    question: {
      id: 2,
      questionTitle: "Organization/Dependability",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 6,
        ratingValue: 1,
        ratingDescription:
          "Disorganized; cannot take direction. Requires close supervision; is unreliable.",
      },
      {
        id: 7,
        ratingValue: 2,
        ratingDescription:
          "Learning how to take direction and prioritize. Sometimes requires prompting.",
      },
      {
        id: 8,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements. Approaches work in an orderly fashion. Usually takes care of necessary tasks and completes with reasonable promptness.",
      },
      {
        id: 9,
        ratingValue: 4,
        ratingDescription:
          "Better than average most of the time. Can research source materials quickly. Requires little prompting; is reliable.",
      },
      {
        id: 10,
        ratingValue: 5,
        ratingDescription:
          "Excellent. Requires no supervision. Thrives under pressure and solving crises; dependable.\r\n",
      },
    ],
  },
  {
    id: 6348,
    question: {
      id: 3,
      questionTitle: "Deadlines/Accuracy/Standards",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 11,
        ratingValue: 1,
        ratingDescription:
          "Disorderly, does not check work, makes frequent errors, never meets deadlines",
      },
      {
        id: 12,
        ratingValue: 2,
        ratingDescription:
          "Tendency to be careless and then miss deadlines. Standards in work production could be improved.",
      },
      {
        id: 13,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements. Meets deadlines, avoids careless errors. Follows-up on outstanding issues.",
      },
      {
        id: 14,
        ratingValue: 4,
        ratingDescription:
          "Better than average. Requires little or no supervision. Is exact and precise most of the time. ",
      },
      {
        id: 15,
        ratingValue: 5,
        ratingDescription:
          "Excellent. Requires no supervision. Accurate and precise. Follows-up on own initiative.",
      },
    ],
  },
  {
    id: 6349,
    question: {
      id: 4,
      questionTitle: "Problem Solving",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 16,
        ratingValue: 1,
        ratingDescription: "Has difficulty solving problems.",
      },
      {
        id: 17,
        ratingValue: 2,
        ratingDescription: "Attempts to recognize a problem and rectify it.",
      },
      {
        id: 18,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements. Recognizes problems; offers solutions.",
      },
      {
        id: 19,
        ratingValue: 4,
        ratingDescription:
          "Better than average. Acts independently in resolving problems; recommends appropriate action.",
      },
      {
        id: 20,
        ratingValue: 5,
        ratingDescription:
          "Excellent. Determines cause of problem; considers alternatives; reliable action taken",
      },
    ],
  },
  {
    id: 6350,
    question: {
      id: 5,
      questionTitle: "Relationships – Patients and Public",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 21,
        ratingValue: 1,
        ratingDescription: "Discourteous, antagonistic, unprofessional manner.",
      },
      {
        id: 22,
        ratingValue: 2,
        ratingDescription:
          "Inconsistent in approach, too informal, lacking confidence.",
      },
      {
        id: 23,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements. Good interaction, tactful, courteous, polite, professional.",
      },
      {
        id: 24,
        ratingValue: 4,
        ratingDescription:
          "Better than average. Demonstrates consideration, caring, effective interaction.\r\n",
      },
      {
        id: 25,
        ratingValue: 5,
        ratingDescription:
          "Excellent. Confident, helpful. Interaction complimented by patients",
      },
    ],
  },
  {
    id: 6351,
    question: {
      id: 6,
      questionTitle: "Relationships – Staff",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 21,
        ratingValue: 1,
        ratingDescription: "Discourteous, antagonistic, unprofessional manner.",
      },
      {
        id: 22,
        ratingValue: 2,
        ratingDescription:
          "Inconsistent in approach, too informal, lacking confidence.",
      },
      {
        id: 23,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements. Good interaction, tactful, courteous, polite, professional.",
      },
      {
        id: 24,
        ratingValue: 4,
        ratingDescription:
          "Better than average. Demonstrates consideration, caring, effective interaction.\r\n",
      },
      {
        id: 25,
        ratingValue: 5,
        ratingDescription:
          "Excellent. Confident, helpful. Interaction complimented by patients",
      },
    ],
  },
  {
    id: 6352,
    question: {
      id: 7,
      questionTitle: "Attendance",
      typeOfResponse: 3,
    },
    ratingCriteria: [
      {
        id: 26,
        ratingValue: 1,
        ratingDescription: "Unhelpful and uncooperative.",
      },
      {
        id: 27,
        ratingValue: 2,
        ratingDescription:
          "Approachable, friendly.  Needs to embrace team concept.",
      },
      {
        id: 28,
        ratingValue: 3,
        ratingDescription:
          "Meets requirements.  Warm, friendly, helpful, comfortable in team setting.",
      },
      {
        id: 29,
        ratingValue: 4,
        ratingDescription:
          "Better than average in helpfulness and courtesy and tone. Shares knowledge with co-workers.",
      },
      {
        id: 30,
        ratingValue: 5,
        ratingDescription:
          "Excellent. Consistently cheerful in attitude. Accommodating and supportive to all co-workers.",
      },
    ],
  },
];

export const GLOBAL_STAFF_HELP_ITEMS = [
  {
    title: "Update Across Offices",
    description:
      "Update this staff member’s details in all selected offices. Only fill in the fields you want to update — leave the rest blank to keep them unchanged.",
  },
  {
    title: "Deactivate Staff",
    description:
      "Deactivate the staff member from selected offices. Deactivated staff can be activated again later.",
  },
  {
    title: "Remove Staff",
    description:
      "Remove the staff member from selected offices. Removed staff lose their previous data but can be re-invited.",
  },
  {
    title: "Cancel Invite",
    description: "Cancel a pending invite for the selected office.",
  },
  {
    title: "Re-notify Staff",
    description: "Send a reminder notification for pending invitations.",
  },
  {
    title: "Re-invite Staff",
    description: "Reinvite staff who were previously removed.",
  },
  {
    title: "Bulk Actions",
    description: "You can also select multiple staff members and use",
    boldText: "Bulk Update Selected",
  },
  {
    title: "Bulk Update Selected",
    description:
      "Update details for multiple staff members across all offices. Enter only the fields that need changes — blank fields will remain unchanged.",
  },
];

export const OFFICE_STAFF_HELP_ITEMS = [
  {
    title: "Deactivate Staff",
    description:
      "Deactivate the staff member from the offices. Deactivated staff can be activated again later.",
  },
  {
    title: "Remove Staff",
    description:
      "Remove the staff member from the offices. Removed staff lose their previous data but can be re-invited.",
  },
  {
    title: "Cancel Invite",
    description: "Cancel a pending invite for the office.",
  },
  {
    title: "Re-notify Staff",
    description: "Send a reminder notification for pending invitation.",
  },
  {
    title: "Re-invite Staff",
    description: "Reinvite staff who were previously removed.",
  },
  {
    title: "Bulk Actions",
    description: "You can also select multiple staff members and use",
    boldText: "Bulk Update Selected",
  },
  {
    title: "Bulk Update Selected",
    description:
      "Update details for multiple staff members in the office. Enter only the fields that need changes — blank fields will remain unchanged.",
  },
  {
    title: "Download Sample File",
    description:
      "Download the sample CSV to understand the required format and fields.",
  },
  {
    title: "Upload Staff CSV",
    description: "Upload the filled CSV to add multiple staff members at once.",
  },
];

export const POLICY_HELP_ITEMS = [
  {
    title: "Current Policies",
    description:
      "The Current Policies section displays all active policy folders along with their latest versions assigned to staff members. This screen helps users track policy status, monitor acknowledgements, and identify pending or overdue actions.",
  },
  {
    title: "Archived Policies",
    description:
      "The Archived Policies section shows policies that have been archived by users. Although archived policies are no longer active, they remain available for reference and record-keeping.",
  },
  {
    title: "Compliance Analytics",
    description:
      "Compliance Analytics provides statistical insights into the policies created in the system. It displays overall policy status, acknowledgement progress, and compliance trends to help users monitor adherence effectively.",
  },
  {
    title: "Policy Versions",
    description:
      "By selecting a policy folder, users can view all versions associated with that policy. From here, they can add one or multiple versions and assign them to staff members. This section also allows tracking acknowledgements specific to each version.",
  },
  {
    title: "Create a New Policy",
    description:
      "Users can create a policy either by selecting the Quick Policy option, which allows them to choose from an existing list for faster setup, or by using the Add Policy option to enter complete details and assign the policy to staff members.",
  },
  {
    title: "Renew Acknowledgement",
    description:
      "The Renew Acknowledgement option, available in the global three-dot menu, allows users to renew previously assigned policies. This action creates a copy of the selected policy and requires staff members to re-acknowledge it.",
  },
  {
    title: "Staff Tracking",
    description:
      "The Staff Tracking screen enables users to monitor the status of policies assigned to individual staff members. It provides visibility into which policies have been acknowledged and which are still pending.",
  },
  {
    title: "Logs",
    description:
      "Users can view the activity history of a policy by selecting History Logs from the global three-dot menu. To review changes specific to a particular version, they can access the version details and view the corresponding change logs.",
  },
  {
    title: "Export",
    description:
      "Users can export the data on the screen by selecting the Export option. The export on the Current Policy list shows the details of created policies, while the Version list export shows details of added versions, and the Staff Tracking export provides details related to policies assigned to staff. Additionally, the exported file contains records according to the applied filters; if the results are filtered, only those filtered results will be exported.",
  },
];

export const bulkUpdatehelpItems = [
  {
    heading: "How It Works",
    points: [
      "You will see a set of fields that represent staff details (such as department, role, etc.).",
      <strong>Enter values only in the fields you want to update.</strong>,
      "Any field you leave blank will not be changed for any selected staff member.",
      <>
        When you submit the form, the system will apply these updates to{" "}
        <b>all selected staff members </b>across <b>all their offices.</b>"
      </>,
    ],
  },
  {
    heading: "Important Notes",
    points: [
      <>
        <b>Blank fields are ignored —</b> existing information for those fields
        stays as-is.
      </>,
      <>
        <b>Only the filled fields </b> will be updated for every selected staff
        member."
      </>,
      <>
        This action updates each staff member in{" "}
        <b>all offices they are linked to </b>, ensuring consistency."
      </>,
      "Use this option carefully, as the same update will apply to all selected staff members.",
    ],
  },
  {
    heading: "When to Use This",
    points: [
      "When many staff members need the same change (e.g., updating a designation, adding a new attribute, correcting common details).",
      "When standardizing information across teams or offices.",
    ],
  },
];

export const bulkUpdateStaffForMultipleOfficeshelpItems = [
  {
    heading: "How It Works",
    points: [
      "The fields on this screen represent the staff member’s details (e.g., contact information, personal details, job-related information).",
      <strong>Enter information only in the fields you want to update.</strong>,
      "If a field is left blank, it will not change in any office.",
      <>
        When you submit the form, the system will apply the changes to the staff
        member in<b>all the offices selected for the update.</b>
      </>,
    ],
  },
  {
    heading: "Important Notes",
    points: [
      <>
        <b>Blank fields are ignored</b> — they will not overwrite existing
        information.
      </>,
      <>
        <b>Only the values you enter will be updated</b> in all selected
        offices.
      </>,
      <>
        If different offices currently have different values for a field, the
        new value you enter will replace the old value in all selected offices.
      </>,
      "This action helps maintain consistent staff information across locations, especially for staff working in multiple offices.",
    ],
  },
];

export const bulkUpdateSingleOfficehelpItems = [
  {
    heading: "How It Works",
    points: [
      "You will see a set of fields representing staff details (such as department, role, or other attributes).",
      <strong>Enter values only in the fields you want to update.</strong>,
      "Fields left blank will not be changed for any selected staff member.",
      <>
        When you submit the form, the system will update the entered fields for{" "}
        <b>all selected staff members in this office.</b>
      </>,
    ],
  },
  {
    heading: "Important Notes",
    points: [
      <>
        <b>Blank fields are ignored —</b> they will not overwrite any existing
        information.
      </>,
      <>
        <b>Only the filled fields </b> will be updated for all selected staff."
      </>,
      "Since all staff belong to the same office, updates will affect only this office and will not impact any other office.",
      "Use this action when the same update applies to several people within a single location.",
    ],
  },
  {
    heading: "When to Use This",
    points: [
      "When multiple team members in the same office need the same update (e.g., new department, updated designation, common attribute changes).",
      "When standardizing or correcting information within a single office.",
    ],
  },
];

export default constants;
